import React, { HTMLAttributes } from 'react';
import { PageIndicatorItem } from './PageIndicatorItem';
import { Stack } from '../stack';
import { useRover } from '../../hooks/useRover';
import { size_styles } from './styles';
import { PageIndicatorItemSize } from './types';

export interface PageIndicatorProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  /** 페이지 이동 가능 여부 */
  disabled?: boolean;
  /** 전체 페이지 수 */
  totalPages: number;
  /** 현재 페이지 번호 */
  page: number;
  /** 페이지가 변경될 때 호출되는 함수 */
  onChange?: (page: number) => void;
  /** @default 'medium' */
  size?: PageIndicatorItemSize;
}

export const PageIndicator: React.FC<PageIndicatorProps> = ({
  disabled,
  totalPages,
  page,
  onChange,
  size = 'medium',
  ...props
}) => {
  const { gap } = size_styles[size];

  const { getRoverItemProps } = useRover({
    index: page - 1,
    onIndexChange: (index, is_selecting) => {
      if (is_selecting) {
        onChange?.(index + 1);
      }
    },
    length: totalPages,
  });

  return (
    <Stack gap={gap} role='tablist' justify='center' {...props}>
      {Array.from({ length: totalPages }).map((_, pageIndex) => (
        <PageIndicatorItem
          key={pageIndex}
          page={pageIndex + 1}
          isSelected={pageIndex + 1 === page}
          onClick={onChange}
          disabled={disabled}
          size={size}
          {...getRoverItemProps(pageIndex, {})}
        />
      ))}
    </Stack>
  );
};
